export default "__VITE_ASSET__CadZ8L4a__"